export enum PreviewTypes {
    EDITOR = 'EDITOR',
    CONTENT = 'CONTENT',
}
